/**
 * Simple Cart Notification Auto-Close
 * Closes after 5 seconds without breaking anything
 */

document.addEventListener('DOMContentLoaded', function() {
  // Listen for when items are added to cart
  document.addEventListener('cart:added', function() {
    setTimeout(function() {
      const closeBtn = document.querySelector('.cart-notification__close');
      if (closeBtn) {
        closeBtn.click();
      }
    }, 5000);
  });
  
  // Alternative method - watch for the notification to appear
  const checkForNotification = setInterval(function() {
    const notification = document.querySelector('cart-notification.animate');
    if (notification && notification.style.visibility !== 'hidden') {
      clearInterval(checkForNotification);
      setTimeout(function() {
        const closeBtn = document.querySelector('.cart-notification__close');
        if (closeBtn) {
          closeBtn.click();
        }
      }, 5000);
    }
  }, 500);
  
  // Stop checking after 30 seconds to prevent infinite loop
  setTimeout(function() {
    clearInterval(checkForNotification);
  }, 30000);
});